/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CancelByIdsResponse
 */
export interface CancelByIdsResponse {
  /**
   *
   * @type {number}
   * @memberof CancelByIdsResponse
   */
  cancelledCount: number;
}

/**
 * Check if a given object implements the CancelByIdsResponse interface.
 */
export function instanceOfCancelByIdsResponse(
  value: object,
): value is CancelByIdsResponse {
  if (!("cancelledCount" in value) || value["cancelledCount"] === undefined)
    return false;
  return true;
}

export function CancelByIdsResponseFromJSON(json: any): CancelByIdsResponse {
  return CancelByIdsResponseFromJSONTyped(json, false);
}

export function CancelByIdsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CancelByIdsResponse {
  if (json == null) {
    return json;
  }
  return {
    cancelledCount: json["cancelledCount"],
  };
}

export function CancelByIdsResponseToJSON(json: any): CancelByIdsResponse {
  return CancelByIdsResponseToJSONTyped(json, false);
}

export function CancelByIdsResponseToJSONTyped(
  value?: CancelByIdsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cancelledCount: value["cancelledCount"],
  };
}
